import React, { useCallback, useRef, useState } from 'react'

type RenderProps = {
  obj: any
  onReadyToPrint: () => void
}

type RenderFunc = (props: RenderProps) => React.ReactNode

interface Props {
  items: any[]
  render: RenderFunc
  onProgress: (progress: number) => void
  onReadyToPrint?: () => void
}

export const BulkPrint = React.memo((props: Props) => {
  const { items, render, onProgress, onReadyToPrint } = props
  const [total] = useState(items.length)
  const numReady = useRef(0)

  const ready = useCallback(() => {
    numReady.current += 1
    onProgress(numReady.current / total)
    if (numReady.current >= total) {
      onReadyToPrint?.()
    }
  }, [onProgress, onReadyToPrint, total])

  return (
    <>
      {items.map((obj: any) => {
        return render({ obj, onReadyToPrint: ready })
      })}
    </>
  )
})
